<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VBaf45/tc-custom/9780830897391.jpg?1696870397594" alt="This image is the cover for the book Twelve Prophets, Ancient Christian Commentary on Scripture"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Twelve Prophets, Ancient Christian Commentary on Scripture
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>"And beginning with Moses and all the prophets, [the risen Jesus] interpreted to them in all the scriptures the things concerning himself" (Lk 24:27).</strong> The church fathers mined the Old Testament throughout for prophetic utterances regarding the Messiah, but few books yielded as much messianic ore as the Twelve Prophets, sometimes known as the Minor Prophets because of the relative brevity of their writings. Encouraged by the example of the New Testament writers, the church fathers found numerous parallels between the Gospels and the prophetic books. Among the events foretold, they found not only the flight into Egypt after the nativity, the passion, and resurrection of Christ, and the outpouring of the Spirit at Pentecost, but also Judas's act of betrayal, the earthquake at Jesus' death and the rending of the temple veil. Detail upon detail brimmed with significance for Christian doctrine, including baptism and the Eucharist as well as the relation between the covenants. In this rich and vital resource you will find excerpts, some translated here into English for the first time, from more than thirty church fathers, ranging in time from Clement of Rome, Justin Martyr, and Irenaeus (late first and early second centuries) to Gregory the Great, Braulio of Saragossa, and Bede the Venerable (late sixth to early eighth centuries). Geographically the sources range from the great Cappadocians—Basil the Great, Gregory of Nazianzus, Gregory of Nyssa—John Chrysostom, Ephrem the Syrian, and Hippolytus in the East, to Ambrose, Augustine, Cyprian, and Tertullian in the West, and Origen, Cyril, and Pachomius in Egypt. This Ancient Christian Commentary on Scripture volume is a treasure trove out of which Christians may bring riches both old and new in their understanding of these ancient texts.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alberto Ferreiro, Thomas C. Oden
      </h2>
      
      <p class="authorDescription body article"><p>Alberto Ferreiro is professor of history at Seattle Pacific University in Seattle, Washington.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Christian
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f8f080a2